import { Reveal } from "@/components/Reveal";
import { RERA } from "@/constants/content";

export const ReraDisclosure = () => (
  <section id="rera" className="cp-section cp-section--white cp-rera-section" data-testid="rera-section">
    <div className="cp-container cp-rera-inner">
      <Reveal>
        <span className="cp-eyebrow">Compliance</span>
        <h2 className="cp-h2">RERA Registration</h2>
        <p className="cp-section-desc">
          Central Plaza is registered with the {RERA.authority}. Registration details are listed
          below.
        </p>
      </Reveal>

      <Reveal delay={0.08} className="cp-rera-card">
        <dl className="cp-rera-details">
          <div>
            <dt>RERA registration no.</dt>
            <dd>{RERA.number}</dd>
          </div>
          <div>
            <dt>Registration date</dt>
            <dd>{RERA.registeredOn}</dd>
          </div>
          <div>
            <dt>Project</dt>
            <dd>{RERA.projectName}</dd>
          </div>
          <div>
            <dt>Location</dt>
            <dd>{RERA.location}</dd>
          </div>
          <div>
            <dt>Promoter</dt>
            <dd>{RERA.promoter}</dd>
          </div>
          <div>
            <dt>License validity</dt>
            <dd>
              License No. {RERA.licenseNo} dated {RERA.licenseDate} — valid until{" "}
              {RERA.licenseValidUntil}
            </dd>
          </div>
        </dl>
      </Reveal>
    </div>
  </section>
);
